export function formatFileSize(
  bytes: number | string | null | undefined
): string {
  if (!bytes) return '-';

  if (typeof bytes === 'string') bytes = parseInt(bytes);

  if (bytes === 0) return '-';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function formatFileName(fullPath: string | null | undefined): string {
  if (typeof fullPath === 'string') {
    let parts = fullPath.split('/');
    // remove all empty elements
    parts = parts.filter((part) => part);
    return parts.length ? parts[parts.length - 1] : '';
  }
  return '-';
}
